import { render } from "./ModalConfirmation.vue?vue&type=template&id=0371e7ec&ts=true"
import script from "./ModalConfirmation.vue?vue&type=script&lang=ts"
export * from "./ModalConfirmation.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__